import { createSelector } from '@reduxjs/toolkit';

import { entityDrawerSelector } from 'src/selectors/entityDrawer';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSensitivePropertyGroupsByNameSelector } from 'src/selectors/projectSensitivePropertyGroupsByName';

export const entityDrawerSensitivePropertyGroupDataSelector =
  memoizeSelectorFactory((projectId: string) =>
    createSelector(
      entityDrawerSelector,
      projectSensitivePropertyGroupsByNameSelector(projectId),
      (drawer, sensitivePropertyGroups) =>
        drawer.entityValue
          ? {
              name: drawer.entityValue,
              attributes: sensitivePropertyGroups[drawer.entityValue] || [],
            }
          : null
    )
  );
